import React from "react";
import LogoImage from "../../assets/images/2018/Logo.png";
import Backgrounds from "./Backgrounds";
import "./styles.less";

const Header = ({ toggleMenu, path, isMobile }) => {
  const backgrounds = isMobile ? Backgrounds.mobile : Backgrounds.desktop;
  let key = Object.keys(backgrounds).find(k => path === k);
  if (!key) {
    key = Object.keys(backgrounds).find(
      k =>
        k !== "/" &&
        k.split("/").filter(value => -1 !== path.split("/").indexOf(value))
    );
  }
  const mobileStyles = {
    backgroundImage: `url(${Backgrounds.mobile[key]})`,
    height: path === "/" ? "260px" : "210px"
  };
  const desktopStyles = {
    backgroundImage: `url(${Backgrounds.desktop[key]})`,
    height: path === "/" ? "300px" : "250px"
  };

  return isMobile ? (
    <div className="header mobile" style={mobileStyles}>
      <div className="menu-toggle" onClick={() => toggleMenu()} />
      <img className="logo" src={LogoImage} />
      <div className="share-dialog" />
    </div>
  ) : (
    <div className="header desktop" style={desktopStyles}>
      <div className="header-wrapper">
        <div className="menu-toggle" onClick={() => toggleMenu()} />
        <img className="logo" src={LogoImage} />
        <div />
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./components/Controls/Header.js